import { Component, Input, OnInit } from '@angular/core';
import { SlideDTO } from '@app/model/slideDTO.model';
import { NavigateService } from '@app/services/navigate.service';
import { PayableNodeNavigationService } from '@app/services/payable-node-navigation.service';
import { InstaLearn, InstaLearnPostsDialogService, InstaLearnApiService } from 'library-explorer';
import { filter } from 'rxjs';

@Component({
    selector: 'app-slide-insta-learn-posts',
    templateUrl: './slide-insta-learn-posts.component.html',
    styleUrls: ['./slide-insta-learn-posts.component.scss'],
    standalone: false
})
export class SlideInstaLearnPostsComponent implements OnInit {
  @Input() public data: SlideDTO;

  public items: InstaLearn[] = [];

  constructor(
    private readonly instaLearnPostsDialogService: InstaLearnPostsDialogService,
    private readonly navigateService: NavigateService,
    private readonly payableNodeNavigationService: PayableNodeNavigationService,
    private readonly instaLearnApiService: InstaLearnApiService) { }

  ngOnInit(): void {
    this.loadCards();
  }

  public navigate(item: InstaLearn): void {
    if (!item) {
      return;
    }

    if (item.link?.uri) {
      this.navigateService.navigate(item.link.uri);
      return;
    }

    this.payableNodeNavigationService.navigate(item.linkToContent);
  }

  public openDialog(index: number): void {
    const dialog = this.instaLearnPostsDialogService.openDialog({ cards: this.items, index });

    dialog.afterClosed()
      .pipe(
        filter(instaLearn => !!instaLearn),
      )
      .subscribe(instaLearn => {
        this.navigate(instaLearn);
      });
  }

  private loadCards(): void {
    this.instaLearnApiService.getInstaLearns({ sort: 'created:DESC' })
      .subscribe(data => {
        this.items?.push(...data.items);
      })
  }
}
